import { z } from "zod";
import { AbstractDictionnarySchema } from "./abstract/abstractDictionary.entities";
import { AwImportIdSchema } from "../traits";

export enum DictionaryScheduleTypeSchemaEnum {
	DictionaryScheduleType = "DictionaryScheduleType"
};

export const DictionaryScheduleTypeSchema = AbstractDictionnarySchema
	.merge(AwImportIdSchema)
	.merge(z.object({
		"@id": z.string(), // "/api/dictionary_schedule_types/1"
		"@type": z.string(), // "DictionaryScheduleType"
		id: z.number(), // 1
		libelle: z.string(), // "AUTRES"
		status: z.string(), // "AUTRES"
		new_label: z.string(), // "AUTRES"
		new_status: z.string(), // "AUTRES"
		new_action: z.string(), // "NOTES"
		new_duration: z.string(), // "30"
		new_background_color: z.string(), // "124323535"
		aw_id: z.string(), // "1"
	}))
	.describe(DictionaryScheduleTypeSchemaEnum.DictionaryScheduleType);

export type DictionaryScheduleType = z.infer<typeof DictionaryScheduleTypeSchema>;
